import * as i0 from "@angular/core";
var SCORES = {
    'en-CA': ['X', 'LE1-', 'LE1=', 'LE1+', 'LE2-', 'LE2=', 'LE2+', 'LE3-', 'LE3=', 'LE3+', 'LE4-', 'LE4='],
    'fr-CA': ['X', 'FJ1-', 'FJ1=', 'FJ1+', 'FJ2-', 'FJ2=', 'FJ2+', 'FJ3-', 'FJ3=', 'FJ3+', 'FJ4-', 'FJ4=']
};
var Scores = /** @class */ (function () {
    function Scores() {
    }
    Scores.prototype.thumb = function (language) {
        return function (score) {
            return SCORES[language || 'en-CA'][score];
        };
    };
    Scores.prototype.label = function (score, language) {
        if (!language) {
            return '';
        }
        return SCORES[language][score];
    };
    Scores.ngInjectableDef = i0.defineInjectable({ factory: function Scores_Factory() { return new Scores(); }, token: Scores, providedIn: "root" });
    return Scores;
}());
export { Scores };
